import React from 'react'
import Button from './button';
import "./stylesheet/resume.css";

const Resume = () => {
  return (
    <div className="resume">
      <h1>For Education Download my resume!</h1>
        <div className="flex">
            <div className="circle"></div>
            <div className="text1">
                <h2>Want To hire me for role?</h2>
                <a href={"https://umangsahu.github.io/media/Resume.pdf"} target="_blank" download>
                <Button title={"Resume"} subtext={"Download My"}/>
                <div className="sec-circle"></div>
                </a>
            </div>
        </div>
    </div>
  )
}

export default Resume